export enum eTypePickingRoute {
  Estandar = 1,
  RTV = 2,
  ExternalStorage = 3,
  Recall = 4,
  Venta_En_Verde = 5
}
